import { cloneDeep } from 'lodash';

export function setIsLoadingCancelationServiceDate(state, payload) {
  state.isLoadingCancelationServiceDate = payload;
}
export function setIsCancelationServiceActive(state, payload) {
  state.isCancelationServiceActive = payload;
}
export function setStartDate(state, payload) {
  state.shouldRefreshContracts = true;
  state.startDate = payload;
}
export function setSelectedAgreementId(state, payload) {
  state.selectedAgreementId = payload;
}
export function setShouldResetSelectedAgreementId(state, payload) {
  state.shouldResetSelectedAgreementId = payload;
}

export function clearNewInsuredPerson(state) {
  state.shouldRefreshContracts = true;
  state.newlyInsuredPersons = {};
  state.isLoadingCancelationServiceDate = undefined;
  state.isCancelationServiceActive = undefined;
  state.shouldResetSelectedAgreementId = undefined;
  state.startDate = undefined;
}

export function addNewInsuredPerson(state, payload) {
  state.shouldRefreshContracts = true;
  state.newlyInsuredPersons[payload.guid] = payload.form;
}
export function removeNewInsuredPerson(state, payload) {
  state.shouldRefreshContracts = true;
  const clone = cloneDeep(state.newlyInsuredPersons);
  delete clone[payload];
  state.newlyInsuredPersons = clone;
}

export function setShouldRefreshContracts(state, payload) {
  state.shouldRefreshContracts = payload;
}

export function setFormProperty(state, payload) {
  state.shouldRefreshContracts = true;
  const clone = cloneDeep(state.newlyInsuredPersons);
  const updatedForm = Object.assign(clone[payload.guid], payload.field);
  state.newlyInsuredPersons[payload.guid] = updatedForm;
}

export function updateMedicalSelectionForNewlyInsuredPerson(state, payload) {
  state.newlyInsuredPersons[payload.key].medicalSelection = payload.medicalSelection;
}
export function setCoInsuredOnForms(state) {
  const clone = cloneDeep(state.newlyInsuredPersons);

  const keys = Object.keys(clone);
  keys.forEach((key) => {
    if (clone[key].role !== 'P') {
      clone[key].role = 'M';
    }
  });
  state.newlyInsuredPersons = clone;
}
export function setStartDateOfNewBorn(state, payload) {
  state.startDate = payload;
}
